import { createReduxModule } from 'utils/reduxUtils';

import reducer from './reducer';
import sagas from './sagas';

export * from './actions';
export * from './constants';
export * from './selectors';

export default createReduxModule('notifications', reducer, sagas);
